import { FsGroupFormGroup } from "./fund-strategy-export-types";

export class FundStrategyModel {
  constructor(
    public uuid?: string,
    public name: string = '',
    public totalCommitment: number = 0,
    public expectedExpenses: number = 0,
    public orgUUID: string = '',
    public groups: GroupFS[] = [],
    public lastSaveText: string = '',
    public lastUpdateDate?: Date,
    public createdDate?: Date,
    public createdBy: string = '',
  ) {
  }
}
export class GroupFS {
  constructor(
    public uuid?: string,
    public name: string = '',
    public grOrder: number = 0,
    public subGroups: SubGroupFS[] = [],
  ) {
  }
}

export class SubGroupFS {
  constructor(
    public uuid?: string,
    public name: string = '',
    public subGrOrder: number = 0,
    public roundsData: RoundsFS[] = [],
  ) {
  }
}

export class RoundsFS {
  constructor(
    public uuid?: string,
    public name: string = '',
    public roundOrder: number = 0,
    public companiesNumber: number = 0,
    public esop: number = 0,
    public preMoney: number = 0,
    public round: number = 0,
    public investment: number = 0,
    public writeOff: number = 0,
    public exitCompNumber: number = 0,
    public exitCompPrice: number = 0,
    // will not be saved in the database
    public holding?: number,
    public totalInvestment?: number,
    public proceeds?: number,
    public exitProceeds?: number,
    public exitMoic?: number,
    public postMoney?: number,
  ) {
  }
}

export class TotalsFS {
  constructor(
    public companiesNumber: number = 0,
    public writeOff: number = 0,
    public exitCompNumber: number = 0,
    public investment: number = 0, // total of total investments
    public proceed: number = 0,
    public gain: number = 0,
    public moic: number = 0,
  ) {
  }
}

export class SaveModelEmitterDTO {
  groups: GroupFS[];
  message: string;
  grIndex: number;
  sbIndex: number;
  newOrder: number;
}

export class FSFundMetrics {
  constructor(
    public totalCommitment: number = 0,
    public unAllocatedCommitment: number = 0,
    public expectedExpenses: number = 0,
    public expectedExpensesPcnt: number = 0,
    public investment: number = 0,
    public proceeds: number = 0,
    public gain: number = 0,
    public tvpi: number = 0,
  ) {
  }
}

export class FSFundMetricsDTO {
  constructor(
    public totalCommitment: number = 0,
    public expectedExpenses: number = 0,
    public investment: number = 0,
    public proceeds: number = 0,
  ) {}

  get gain(): number {
    return this.proceeds - this.investment - this.expectedExpenses;
  }

  get expectedExpensesPcnt(): number {
    return (this.expectedExpenses / this.totalCommitment) * 100;
  }

  get unAllocatedCommitment(): number {
    return this.totalCommitment - this.expectedExpenses - this.investment;
  }

  get tvpi(): number {
    if (this.unAllocatedCommitment < 0) {
      return this.totalCommitment ? Math.abs(this.proceeds / this.totalCommitment) : 0;
    }
    return Math.abs(this.proceeds / (this.investment + this.expectedExpenses));
  }
}

export class FSFundMetricsMiniDTO {
  constructor(
    public totalCommitment: number = 0,
    public expectedExpenses: number = 0,
  ) {}
}

export class FSPortfolioMetrics {
  constructor(
    public name: string = '',
    public companiesNumber: number = 0,
    public investment: number = 0,
    public proceeds: number = 0,
    public gain: number = 0,
    public moic: number = 0,
  ) {}

  updateMetrics(exitCompNumber: number, rInvestment: number, proceeds: number): void {
    this.companiesNumber += exitCompNumber;
    this.investment += rInvestment * exitCompNumber;
    this.proceeds += proceeds * exitCompNumber;
  }

  calculateGain(): void {
    this.gain = this.proceeds - this.investment;
  }

  calculateMoic(): void {
    this.moic = this.investment ? (this.proceeds / this.investment) : 0;
  }

}

export class AtCostFSPortfolioMetrics extends FSPortfolioMetrics {
  name = 'At cost';
}

export class AtLossFSPortfolioMetrics extends FSPortfolioMetrics {
  name = 'At loss';
}

export class AtGainFSPortfolioMetrics extends FSPortfolioMetrics {
  name = 'At gain';
}

export class WriteOffFSPortfolioMetrics extends FSPortfolioMetrics {
  name = 'Write-off';
}

export class TotalFSPortfolioMetrics extends FSPortfolioMetrics {
  name = 'Total';
}

export class FSPortfolioMetricsDTO {
  constructor(
    public proceeds: number = 0,
    public investment: number = 0,
  ) {}
}

export interface FundStrategyExportExcelData {
  groups: FsGroupFormGroup[];
  metrics: FSFundMetrics;
};
